export default {"src":"/_next/static/media/info-circle.d06e5b7e.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};